export default class MessageUtil {
  static isMessageImportant = (value) => {
    if (!value) return false;
    return (["your action needed!", "update payment method!", "credit card expired!"].indexOf(value.trim().toLowerCase()) > -1);
  }
}